import algolia from "algoliasearch/lite";
import { Index } from "algoliasearch";

export default ({ application_id, search_api_key, index_name }): Index => {
  return algolia(application_id, search_api_key).initIndex(index_name) as Index;
};
